<template>
  <div id="clauseContainer">
    <h5>{{data.title}}</h5>
    <p class="desc" v-if="data.desc !== ''" v-html="data.desc"></p>
    <ul class="content_list" v-if="data.content !== ''">
      <li  class="content" v-for="(item, index) in data.content" :key="index">
        <p><span v-html="item"></span></p>
      </li>
    </ul>
    <ul>
      <li v-if="type === 'search'" class="search" v-for="(item, index) in data.list" :key="index" >
        <p v-html="item"></p>
      </li>
      <li v-if="type === 'policy'" class="policy" v-for="(item, index) in data.list" :key="index" >
        <h4>{{item.title}}</h4>
        <p class="clause_desc" v-if="item.desc != undefined && item.desc != ''" v-html="item.desc"></p>
        <div class="clause_options" v-if="item.options != undefined && item.options != ''" v-for="(option, idx) in item.options" :key="idx">
          <p v-html="option"></p>
        </div>
      </li>
      <li v-if="type === 'statement'" class="statement" v-for="(item, index) in data.list" :key="index">
        <p v-html="item"></p>
      </li>
    </ul>
  </div>
</template>

<script>
import { clauseData } from "./../libs/clause.js";
export default {
  name: "ClauseContainer",
  props: {
    clause: Array
  },
  data() {
    return {
      data: {},
      type: ""
    };
  },
  watch: {
    clause: function() {
      this.init();
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      let clause = this.clause[0];
      this.type = clause;
      this.data = clauseData[clause];
    }
  }
};
</script>

<style scoped>
#clauseContainer {
  width: 100%;
  height: 100%;
  margin-top: 32px;
  box-sizing: border-box;
  overflow: scroll;
}
#clauseContainer::-webkit-scrollbar {
  display: none;
}
#clauseContainer h5 {
  width: 100%;
  height: 33px;
  font-size: 24px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 33px;
  margin-bottom: 32px;
}
.clause_options {
  box-sizing: border-box;
  /* padding-left: 46px; */
  position: relative;
}
#clauseContainer p{
  width: 100%;
  font-size: 16px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 35px;
  margin-bottom: 24px;
  overflow: hidden;
}

.query {
  display: block;
  margin: 32px 0 172px 0;
}
.desc {
  font-size: 16px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 35px;
  margin-bottom: 32px;
}
#clauseContainer ul {
  overflow: hidden;
}
.statement {
  font-size: 16px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 35px;
  margin-bottom: 32px;
}
.policy {
  margin-bottom: 32px;
}
.content {
  line-height: 35px;
}

.search h4, .policy h4 {
  height: 35px;
  font-size: 16px;
  font-family: PingFangSC-Semibold;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  line-height: 35px;
  margin-bottom: 24px;
}
.clause_desc {
  width: 1254px;
  font-size: 16px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 35px;
  margin-bottom: 32px;
}
.content_list {
  margin-bottom: 40px;
}
</style>
<style>
#clauseContainer a,
#clauseContainer i {
  font-style: normal;
  color: #0a76f5;
  text-decoration-line: underline;
}
#clauseContainer span {
  font-weight: bold;
}
.el-cascader-node:hover {
  background:rgba(240,241,245,1);
}
.el-cascader-node__label:hover {
  color: #E02433 !important;
}

#clauseContainer strong {
  display: block;
  margin-bottom: 8px;
}
.content em {
  color: #017AFF;
  font-weight:500;
  font-style: normal;
  line-height: 35px;
}
</style>
